import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon OrdersIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const OrdersIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 70 70">
      <g id="Group_4235">
        <g id="Group_4230">
          <g id="Group_4178">
            <g id="Group_4173">
              <g id="Path_2010">
                <path d="M39.86,50.17H19.67c-1.89,0-3.43-1.54-3.43-3.43V22.16c0-1.89,1.54-3.43,3.43-3.43h24.92 c1.89,0,3.43,1.54,3.43,3.43V38.4h-2V22.16c0-0.79-0.64-1.43-1.43-1.43H19.67c-0.79,0-1.43,0.64-1.43,1.43v24.58 c0,0.79,0.64,1.43,1.43,1.43h20.19V50.17z" />
              </g>
              <g id="Path_1982">
                <path fill="#FFFFFF" d="M17.24,29h10.77" />
                <rect x={17.24} y={28} width={10.77} height={2} />
              </g>
              <g id="Path_1984">
                <path fill="#FFFFFF" d="M35.79,29h11.89" />
                <rect x={35.79} y={28} width={11.89} height={2} />
              </g>
              <g id="Path_1983">
                <path d="M36.21,32.33c-0.28,0-0.56-0.1-0.82-0.29c-0.48-0.36-2.12-1.47-2.96-2.05 c-1.15,0.65-2.78,1.58-3.15,1.81c-0.67,0.41-1.2,0.18-1.39,0.06c-0.66-0.4-0.65-1.22-0.63-1.46V18.73h10.33v11.24 c0.06,1.13-0.21,1.9-0.8,2.21C36.6,32.29,36.41,32.33,36.21,32.33z M32.53,27.65L33.04,28c0.08,0.06,1.48,1,2.54,1.73v-9h-6.33 v8.77c1.11-0.63,2.65-1.5,2.74-1.56L32.53,27.65z" />
              </g>
            </g>
          </g>
          <g id="Group_4186">
            <g id="Group_4188">
              <g id="Ellipse_33">
                <g>
                  <circle fill="none" cx={48.64} cy={47.01} r={9.78} />
                </g>
                <g>
                  <path d="M48.64,56.76c-5.38,0-9.75-4.37-9.75-9.75s4.37-9.75,9.75-9.75s9.75,4.37,9.75,9.75 S54.02,56.76,48.64,56.76z M48.64,39.26c-4.27,0-7.75,3.48-7.75,7.75s3.48,7.75,7.75,7.75s7.75-3.48,7.75-7.75 S52.91,39.26,48.64,39.26z" />
                </g>
              </g>
              <g id="Group_4187">
                <g id="Path_2011">
                  <path d="M48.89,48.34c-0.2,0-0.4-0.08-0.54-0.23c-0.28-0.3-0.27-0.78,0.03-1.06l3.12-2.95 c0.3-0.28,0.77-0.27,1.06,0.03c0.28,0.3,0.27,0.78-0.03,1.06l-3.12,2.95C49.26,48.27,49.07,48.34,48.89,48.34z" />
                </g>
                <g id="Path_2012">
                  <path d="M48.83,48.39c-0.24,0-0.47-0.11-0.61-0.32l-3-4.22c-0.24-0.34-0.16-0.81,0.18-1.05 c0.34-0.24,0.81-0.16,1.05,0.18l3,4.22c0.24,0.34,0.16,0.81-0.18,1.05C49.13,48.35,48.98,48.39,48.83,48.39z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
export default OrdersIcon
